/**
 * Normalizes Segment's `ajs_anonymous_id` cookie value to a plain UUID string.
 * Segment JSON-stringifies values before writing them to cookies.
 */
function parseSegmentAnonymousId(rawId?: string) {
  if (!rawId) {
    return undefined;
  }

  const trimmedId = rawId.trim();

  if (!trimmedId) {
    return undefined;
  }

  try {
    const parsed = JSON.parse(trimmedId);

    if (typeof parsed === "string") {
      const normalizedId = parsed.trim();
      return normalizedId.length ? normalizedId : undefined;
    }
  } catch {
    // Fall through to strip optional wrapping quotes from legacy values.
  }

  const withoutQuotes = trimmedId.replace(/^["']+|["']+$/g, "").trim();

  return withoutQuotes.length ? withoutQuotes : undefined;
}

export { parseSegmentAnonymousId };
